"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _prismicConfiguration = require("../prismic-configuration");
var _faq = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper/faq"));
var _infoPageMenu = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper/infoPageMenu"));
var _infoPage = _interopRequireDefault(require("@deosite/helpers/prismicDataMapper/infoPage"));
var _cache = require("@deosite/helpers/cache");
var _prismicHelper = require("../prismicHelper");
var _prismicErrorHandle = _interopRequireDefault(require("@deosite/helpers/prismicErrorHandle"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(uid, language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, _response$data$faq, _response$data$menu, response, faq, menu, mappedPage, mappedFaq, mappedMenu, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            });
          case 2:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 9:
            _context.prev = 9;
            _context.next = 12;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: "infopage",
              uid: uid,
              lang: lang
            });
          case 12:
            response = _context.sent;
            if (response) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return", false);
          case 15:
            if (!((_response$data$faq = response.data.faq) !== null && _response$data$faq !== void 0 && _response$data$faq.id)) {
              _context.next = 21;
              break;
            }
            _context.next = 18;
            return (0, _prismicConfiguration.Client)().getByID(response.data.faq.id);
          case 18:
            _context.t0 = _context.sent;
            _context.next = 22;
            break;
          case 21:
            _context.t0 = false;
          case 22:
            faq = _context.t0;
            if (!((_response$data$menu = response.data.menu) !== null && _response$data$menu !== void 0 && _response$data$menu.id)) {
              _context.next = 29;
              break;
            }
            _context.next = 26;
            return (0, _prismicConfiguration.Client)().getByID(response.data.menu.id);
          case 26:
            _context.t1 = _context.sent;
            _context.next = 30;
            break;
          case 29:
            _context.t1 = false;
          case 30:
            menu = _context.t1;
            mappedPage = (0, _infoPage["default"])(response);
            mappedFaq = (0, _faq["default"])(faq);
            mappedMenu = (0, _infoPageMenu["default"])(menu);
            _context.next = 36;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(uid, ".json"),
              result: _objectSpread(_objectSpread({}, mappedPage), {}, {
                faq: mappedFaq === null || mappedFaq === void 0 ? void 0 : mappedFaq.content,
                menu: mappedMenu === null || mappedMenu === void 0 ? void 0 : mappedMenu.content
              })
            });
          case 36:
            return _context.abrupt("return", _objectSpread(_objectSpread({}, mappedPage), {}, {
              faq: mappedFaq === null || mappedFaq === void 0 ? void 0 : mappedFaq.content,
              menu: mappedMenu === null || mappedMenu === void 0 ? void 0 : mappedMenu.content
            }));
          case 39:
            _context.prev = 39;
            _context.t2 = _context["catch"](9);
            _context.next = 43;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: uid
            });
          case 43:
            _yield$getLanguage2 = _context.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 48;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 48:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t2, "Prismic - info page"));
          case 49:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 39]]);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;